// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"82e7d78d","787":"545aecf5","850":"699beebf"}[chunkId] + ".chunk.js";
};